import React from "react";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import { ModelElementType } from "@/components/entities";
import { SectionRule } from "components/common/SectionRule";
import { ModelRows } from "./ModelRows";
import { PINNED_LIMIT } from "./selectors";

interface PinnedColumnProps {
  /** The rows to show: the first PINNED_LIMIT, or every pin once expanded. */
  models: ModelElementType[];
  total: number;
  expanded: boolean;
  onToggle: () => void;
  /** The list box, sized by the page like Recent's. */
  list: React.ComponentProps<"div">;
}

export const PinnedColumn: React.FC<PinnedColumnProps> = ({
  models,
  total,
  expanded,
  onToggle,
  list,
}) => (
  <>
    <SectionRule
      inset
      icon={<StarBorderOutlinedIcon sx={{ fontSize: 14 }} />}
      label={expanded ? `All pinned · ${total}` : "Pinned"}
      action={
        total > PINNED_LIMIT
          ? {
              label: expanded ? "Show less" : `Show all · ${total}`,
              onClick: onToggle,
              testId: "toggle-all-pinned",
            }
          : undefined
      }
    />
    <div {...list}>
      <ModelRows models={models} byPin movable />
    </div>
  </>
);
